import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Typewriter = ({ phrases = [], typeSpeed = 100, deleteSpeed = 50, pauseTime = 2000 }) => {
    const [index, setIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const [reverse, setReverse] = useState(false);
    const [blink, setBlink] = useState(true);

    // Blinking cursor effect
    useEffect(() => {
        const timeout2 = setTimeout(() => {
            setBlink((prev) => !prev);
        }, 500);
        return () => clearTimeout(timeout2);
    }, [blink]);

    useEffect(() => {
        if (!phrases.length) return;

        if (subIndex === phrases[index].length + 1 && !reverse) {
            const timeout = setTimeout(() => {
                setReverse(true);
            }, pauseTime);
            return () => clearTimeout(timeout);
        }

        if (subIndex === 0 && reverse) {
            setReverse(false);
            setIndex((prev) => (prev + 1) % phrases.length);
            return;
        }

        const timeout = setTimeout(() => {
            setSubIndex((prev) => prev + (reverse ? -1 : 1));
        }, reverse ? deleteSpeed : typeSpeed);

        return () => clearTimeout(timeout);
    }, [subIndex, index, reverse, phrases, typeSpeed, deleteSpeed, pauseTime]);

    return (
        <span className="inline">
            <span>{phrases[index].substring(0, subIndex)}</span>
            <motion.span
                animate={{ opacity: [1, 0] }}
                transition={{ duration: 0.5, repeat: Infinity, repeatType: 'reverse' }}
                className="ml-1 w-1 h-[1em] bg-primary-600 inline-block align-middle"
            />
        </span>
    );
};

export default Typewriter;
